import React from "react";

import classNames from "classnames";

export type Impact = 1 | 2 | 3 | 4 | 5;

function ImpactRenderer({
  impact,
  inline,
  size = "lg",
}: {
  impact: Impact;
  inline?: boolean;
  size?: "sm" | "md" | "lg";
}) {
  const className = inline ? "inline-flex" : "flex";
  const barClassName =
    size === "sm"
      ? "m-[1px] w-[3px] h-[10px]"
      : size === "md"
      ? "m-[1px] w-[4px] h-[11px]"
      : "m-[2px] w-[5px] h-[18px]";
  return (
    <div className={className}>
      {Array(5)
        .fill(undefined)
        .map((_, i) => {
          return (
            <div
              key={i}
              className={classNames(
                "rounded-[2px]",
                barClassName,
                // N.B.: when impact is undefined, i < impact is always false;
                // all segments are inactive
                i < impact
                  ? "bg-[var(--color-green-600)]"
                  : "bg-bg-[var(--color-gray-300)]",
              )}
            />
          );
        })}
    </div>
  );
}

export default ImpactRenderer;
